module.exports = __webpack_public_path__ + "static/media/Login_Img.df22cc81.png";